jQuery(window).on('load', function () {
    function requestHandler(id, name, value, current_name) {
        var data = {};
        data[name] = value;
        data.id = id;

        $.post($('body').attr('data-base-url') + "users/post", data, function( responseTxt ) {
            var response = JSON.parse(responseTxt);

            if(response.status === 'success') {               
                if(response.update === 1) {
                    if(name=="first_name" || name=="last_name" )
                    {
                        $("#profile_img").html(current_name);
                    }
                }
                saveToast();
            }
        });
    }

    function initialize() {
        $('body.users .edit').on('change', 'input, textarea, select', function () {
            const $this = $(this);
            const id = $this.attr('data-id');
            const name = $this.attr('name');
            const value = $this.val();
            const current_name = $('[name="first_name"]').val()+' '+$('[name="last_name"]').val();

            if (id && name && value && filterInput(name)) {
                requestHandler(id, name, value, current_name);
            }
        });
    }

    function filterInput(name) {
        return !Utils.contains(name, 'email_address');
    }

    if (window.UserController === undefined) {
        window.UserController = {};
    }

    window.UserController = {
        initialize: initialize
    };

    UserController.initialize();
});

